export default __webpack_public_path__ + "static/media/berlin-1.4ad50f63.jpg";